export default (settings: any) => settings['adaptableColumns'] * ((settings['entities'] * 10 + settings['columns'] * 2) / 60)
